if (typeof jQuery_T4NT !== 'undefined') {
  jQuery_T4NT(document).ready(function($) {
    jQuery_T4NT('#purchase_codet4').remove();
  });
} else {
  console.warn("⚠️ jQuery_T4NT is not available");
}



document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ custom.js is loaded");

  const waitForBrandsMenu = setInterval(() => {
    const brandsMenuItem = document.querySelector('#item_dropdown_AdbeEd');

    if (brandsMenuItem) {
      console.log("✅ Brands menu item found, binding hover");

      brandsMenuItem.addEventListener('mouseenter', function () {
        const brandsMenu = document.querySelector('#item_dropdown_AdbeEd .lazy_menu');
        const dropdownWrapper = document.querySelector('#item_dropdown_AdbeEd .sub-menu');

        // Set dropdown container width
        if (dropdownWrapper) {
          dropdownWrapper.style.width = '450px';
        }

        // Apply vertical-first 2-column layout
        if (brandsMenu && !brandsMenu.classList.contains('columns-applied')) {
          console.log("✅ Brands menu found, applying column layout");

          brandsMenu.style.display = 'block';
          brandsMenu.style.columnCount = '2';
          brandsMenu.style.columnGap = '40px';
          brandsMenu.style.maxHeight = 'none';
          brandsMenu.style.overflowY = 'visible';
          brandsMenu.style.paddingRight = '10px';

          // Prevent breaking items mid-column
          const menuItems = brandsMenu.querySelectorAll('.menu-item');
          menuItems.forEach(item => {
            item.style.breakInside = 'avoid';
          });

          brandsMenu.classList.add('columns-applied');
        }
      });

      clearInterval(waitForBrandsMenu);
    } else {
      console.log("⏳ Waiting for Brands menu item...");
    }
  }, 200);
});

